import { Zoom, FormControlLabel, FormGroup, Switch } from '@mui/material';
import { switchStyle } from './style';

export default function SwitchUi(props) {
  const {
    className,
    label,
    labelPlacement,
    name,
    checked,
    onChangeHandler,
    color,
    sx = undefined,
    isShown = true,
    unmountOnExit = true,
  } = props;
  const { switchUi } = switchStyle;
  return (
    <Zoom
      in={isShown}
      timeout={{ enter: 300, exit: 500 }}
      mountOnEnter
      unmountOnExit={unmountOnExit}
    >
      <FormGroup
        aria-label='position'
        sx={{ ...switchUi, ...sx }}
        row
        className={className}
      >
        <FormControlLabel
          name={name}
          control={
            <Switch
              checked={checked}
              onChange={onChangeHandler}
              color={color}
            />
          }
          label={label}
          labelPlacement={labelPlacement}
        />
      </FormGroup>
    </Zoom>
  );
}
